import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            <i className="ri-mail-send-line text-primary-500 mr-2"></i>
            {contactData.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mb-8">
            {contactData.subtitle}
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-lg mx-auto">
            <div className="bg-background-50 rounded-lg p-5 text-center">
              <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100">
                <i className="ri-mail-line text-lg text-primary-500"></i>
              </div>
              <p className="text-xs text-foreground-500 mb-1">爆料邮箱</p>
              <p className="text-sm font-medium text-foreground-800">{contactData.email}</p>
            </div>
            <div className="bg-background-50 rounded-lg p-5 text-center">
              <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100">
                <i className="ri-wechat-line text-lg text-accent-500"></i>
              </div>
              <p className="text-xs text-foreground-500 mb-1">微信助手</p>
              <p className="text-sm font-medium text-foreground-800">{contactData.wechat}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}